export const UIEVENT_UIACT = 'UIACT'; // Wyświetlenie strony
export const UIEVENT_UIEXT = 'UIEXT'; // Wyświetlenie zewnętrznej strony
